<template>
    <div class="containter bg-white">
        <div class="top_title f-b">
            <div class="font">{{ topTitle }}</div>
            <el-button type="text" @click="jump">查看详细信息</el-button>
        </div>
        <div class="productInfo">
            <div class="label f-b">
                <div>产品信息</div>
                <div>{{ styLabel }}</div>
            </div>
            <div class="product f-b" v-for="item in data" :key="item.skuCode">
                <div class="info f">
                    <el-popover placement="right" width="280" trigger="hover">
                        <el-image :src="item.imgUrl" fit="cover" />
                        <el-image slot="reference" :src="item.imgUrl" fit="cover" style="width: 60px;height: 60px" />
                    </el-popover>
                    <div class="font">
                        <el-tooltip class="item" effect="dark" :content="item.skuName" placement="top">
                            <div style="margin-bottom: 10px;font-size: 14px" class="ellipsis">{{ item.skuName }}</div>
                        </el-tooltip>
                        <div style="font-size: 12px;color: #454545;">
                            SKU：
                            <copy :text="item.sku" />
                        </div>
                    </div>
                </div>
                <div style="width: 76px" class="f--c">
                    {{ item.qty }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import copy from '@/components/copy.vue'
export default {
    props: {
        type: {
            type: String,
            default: () => 'salesSort'
        },
        data: {
            type: Array,
            default: ()=> []
        },
        chartTime: {
            type: Array,
            default: ()=> []
        }
    },
    components: { copy },
    data() {
        return {
            titleObj: {
                salesSort: {
                    title: '产品销量排名',
                    styLabel: '销量'
                },
                visitorSort: {
                    title: '产品浏览量排名',
                    styLabel: '浏览量'
                },
                cartSort: {
                    title: '加购购物车产品排名',
                    styLabel: '添加购物车'
                }
            }
        }
    },
    computed: {
        topTitle() {
            return this.titleObj[this.type].title
        },
        styLabel() {
            return this.titleObj[this.type].styLabel
        }
    },
    methods: {
        jump() {
            let startTime = this.chartTime[0].valueOf()
            let endTime = this.chartTime[1].valueOf()
            const typeMap = {
                salesSort: 'salesVolumeQty',
                visitorSort: 'visitorQty',
                cartSort: 'cartQty'
            }
            this.$router.push({
                path: '/statistics/product-statistics',
                query: {
                    sort: typeMap[this.type],
                    startTime,
                    endTime
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.containter {
    width: 32%;
    min-width: 400px;
    padding: 20px;
    .top_title {
        >.font {
            font-weight: bold;
            height: 40px;
            line-height: 40px;
        }
    }
    .productInfo {
        >.label {
            height: 40px;
            line-height: 40px;
            >div:nth-of-type(2) {
                width: 80px;
            }
        }
        .product {
            margin-bottom: 10px;
            padding: 4px;
            transition: all .5s;
            background-color: #fff;
            .info {
                .font {
                    margin-left: 4px;
                    >div {
                        line-height: 20px;
                        min-width: 220px;
                        max-width: 320px;
                    }
                }
            }
        }
        .product:hover {
            background-color: #f4f5f5;
        }
    }
}
</style>